var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-wrapper"
    },
    [
      _vm.defaultView
        ? _c(
            "div",
            {
              staticClass: "cw-dashboard cw-dashboard-default-view"
            },
            [
              _c(
                "courseware-collapsible-box",
                {
                  staticClass: "cw-dashboard-box cw-dashboard-box-full",
                  attrs: {
                    title: _vm.$gettext("Überblick"),
                    open: true
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cw-dashboard-overview"
                    },
                    [
                      _c("courseware-oblong", {
                        attrs: {
                          name: _vm.textChapterFinished,
                          icon: "accept",
                          size: "small"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "oblongValue",
                              fn: function fn() {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.chapterCounter.finished) +
                                      " "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3105516301
                        )
                      }),
                      _vm._v(" "),
                      _c("courseware-oblong", {
                        attrs: {
                          name: _vm.textChapterStarted,
                          icon: "play",
                          size: "small"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "oblongValue",
                              fn: function fn() {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.chapterCounter.started) +
                                      " "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3242145086
                        )
                      }),
                      _vm._v(" "),
                      _c("courseware-oblong", {
                        attrs: {
                          name: _vm.textChapterAhead,
                          icon: "timetable",
                          size: "small"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "oblongValue",
                              fn: function fn() {
                                return [
                                  _vm._v(
                                    " " + _vm._s(_vm.chapterCounter.ahead) + " "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          737899382
                        )
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  staticClass: "cw-dashboard-box cw-dashboard-box-half",
                  attrs: {
                    title: _vm.$gettext("Fortschritt"),
                    open: true
                  }
                },
                [_c("courseware-dashboard-progress")],
                1
              ),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  staticClass:
                    "cw-dashboard-box cw-dashboard-box-half cw-content-loading",
                  attrs: {
                    title: _vm.$gettext("Aktivitäten"),
                    open: true
                  }
                },
                [_c("courseware-dashboard-activities")],
                1
              ),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  staticClass: "cw-dashboard-box cw-dashboard-box-full",
                  attrs: {
                    title: _vm.$gettext("Aufgaben"),
                    open: true
                  }
                },
                [
                  !_vm.userIsTeacher && _vm.teacherStatusLoaded
                    ? _c("courseware-dashboard-tasks")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userIsTeacher && _vm.teacherStatusLoaded
                    ? _c("courseware-dashboard-students")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.taskView
        ? _c(
            "div",
            {
              staticClass: "cw-dashboard cw-dashboard-task-view"
            },
            [
              !_vm.userIsTeacher && _vm.teacherStatusLoaded
                ? _c("courseware-dashboard-tasks")
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsTeacher && _vm.teacherStatusLoaded
                ? _c("courseware-dashboard-students")
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activityView
        ? _c(
            "div",
            {
              staticClass: "cw-dashboard cw-dashboard-activity-view"
            },
            [
              _c(
                "courseware-collapsible-box",
                {
                  staticClass:
                    "cw-dashboard-box cw-dashboard-box-full cw-content-loading",
                  attrs: {
                    title: _vm.$gettext("Aktivitäten"),
                    open: true
                  }
                },
                [_c("courseware-dashboard-activities")],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("courseware-companion-overlay")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }